import { render, staticRenderFns } from "./ImoFalForm5MenuForm.vue?vue&type=template&id=1c8747c1"
import script from "./ImoFalForm5MenuForm.vue?vue&type=script&lang=js"
export * from "./ImoFalForm5MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports